export default "__VITE_ASSET__CSbwVmtt__"